import type { ReactNode } from 'react';
import { CornerFold } from './CornerFold';
import { LangToggle } from './LangToggle';
import { MuteToggle } from './MuteToggle';
import { ThemeToggle } from './ThemeToggle';
import { PageChat } from './chat/ChatDoor';

/**
 * The corner cluster, for the pages that are not the app.
 *
 * App.tsx mounts these five itself, each with the argument for it written
 * beside it, and every one of those arguments applies here too: there is no
 * settings page, and somebody who has landed in the wrong language cannot
 * navigate one written in it. The pages outside the app — the landing page, a
 * public profile, a certificate, the paid task board (retired 2026-10-31), the
 * support desk — used to carry whichever of the five somebody had remembered,
 * so the language switch was missing from the very page most visitors see
 * first. This is the one place that decides, so they cannot drift again.
 *
 * `chat` is the one slot that differs. The default is the door (ChatDoor.tsx):
 * a bubble that mounts the real dock only when it is pressed. A page that
 * already holds an account and a record passes its own; the desk passes
 * `null`, because it is the support console, and a chat bubble over a chat
 * console is two doors into the same room.
 *
 * Position in the tree does not matter: every control here is `position:
 * fixed` and folds away through `data-corner` on <html> (lib/corner.ts).
 */
export function Corner({ chat = <PageChat /> }: { chat?: ReactNode }) {
  return (
    <>
      <MuteToggle />
      <LangToggle />
      <ThemeToggle />
      <CornerFold />
      {chat}
    </>
  );
}
